import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from '../../design-system/settings/variables/Colors';

const StyledDiv = styled.div`
  text-align: center;
  .margin-bottom {
    margin-bottom: 15px;
    .icon {
      color: ${({ isError }: { isError: SuccessMessageProps['isError'] }) =>
        isError ? COLORS.critical : COLORS.success};
    }
  }
`;

interface SuccessMessageProps {
  message: string | React.ReactNode | JSX.Element;
  isError?: boolean;
}

const BoxedMessage: React.FC<SuccessMessageProps> = ({ message, isError }) => {
  return (
    <StyledDiv isError={isError}>
      <div className="margin-bottom">
        <FontAwesomeIcon
          size="2x"
          icon={isError ? faCircleXmark : faCircleCheck}
          className="icon"
        />
      </div>
      {message}
    </StyledDiv>
  );
};

export default BoxedMessage;
